
<template>
  <div class="page-wrap">
    <img class="logo" src="../assets/images/logo.png" alt="">
    <div class="enter-actions">
      <van-button type="primary" @click="authByWechat">
        <img src="../assets/images/wechat-enter.png" alt="" class="margin-right-5">微信授权登录
      </van-button>
      <router-link :to="`/login`">
            <van-button type="default" >手机号授权登录</van-button>
      </router-link>
      <div class="agreement">
        登录即表示同意注册协议
        <a href="javascript:;" @click.stop.prevent="showContract = true">《同城保用户注册协议》</a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NavBar,
  Button,
  Row,
  Col,
  Field,
  CellGroup,
  Toast,
  Checkbox,
  CheckboxGroup,
  Dialog
} from "vant";
import Vue from "vue";
import VeeValidate from "vee-validate";
import axios from "axios";
import _ from "lodash";
import { check_card } from "../pages/util/common";

import WechatAuth from '../assets/wechat-auth';

import querystring from 'querystring';
import url from 'url';

Vue.use(VeeValidate);

export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },

  name: "register",
  data: function() {
    return {
      showContract: false,
      inputs: {
        username: "",
        password: "",
        code: "",
        name: "",
        id_number: "",
        remember: true,
        agreement: true
      },
      viewpassword: false,
      countdown: {
        seconds: 120,
        working: false,
        handler: -1
      }
    };
  },
  computed: {
    btnDisabled: function() {
      return !this.inputs.agreement;
    }
  },
  mounted() {
    let cuser = this.$store.state.user;
    if (!_.isEmpty(cuser)) {
      //如果已经登录
      this.$router.replace("/"); //
      return;
    } 

    // 用于跳转到这个页面时，进行的code切割，然后走下一步获取token流程
    let query = querystring.parse(url.parse(window.location.href).query);
    let code = query.code;
    if (code) {
      this.urlCodeQueryFilter(code);
      return;
    }
    let authCode = this.wechatAuth.getAuthCode()
    if (authCode && !this.wechatAuth.getAccessToken()) {
      this.wechatAuth.getCodeCallback(() => {
      });
    }
  },
  created() {
    this.submitForm = _.throttle(this.onSubmit, 2000);

    this.wechatAuth = new WechatAuth({
      appid: this.$wechat.appid, // 您的微信appid
      responseType: 'code',  // 返回类型，请填写code
      scope: 'snsapi_userinfo',
      getCodeCallback: this.onCodeGet
    })
  },
  methods: {
    urlCodeQueryFilter (code) {
      if (code) {
        this.wechatAuth.setAuthCode(code)
        this.wechatAuth.removeUrlCodeQuery()
      }
    },
    /**
     * 满足几个条件： 
     * 1. 支持任意页面跳转到本地，并且支持 redirect 参数，类似之前的，登录完毕后，有能力跳转
     * 2. 当前页面是从其他页面过来的，
     */
    onCodeGet(code, next) {
      this.$http.get('/api/wechat/auth', {
          params: {
            code,
            state: ''//这里可以用于追溯从哪里来的，比如说分享的id
          }
        }).then((response) => {
          if (response) {
            
            let data = response.data
            let newOpenid = data.data['openid'];
            let accessToken = data.data['access_token'];
            // console.log("准备持久化openid", openid);
            if (!_.isEmpty(newOpenid)) {
              this.$store.commit('openid', newOpenid);//保存openid信息
              
              axios.post("/api/user/tryWechatLogin", {openid: newOpenid}).then(res => {
                if (res) {
                  this.$store.commit("login", res.data.data);
                  this.$router.push('/order/new');
                }
              })
            }
            if (accessToken) {
              next(accessToken) // 获取access_toeken成功
            } else {
              next() // 获取access_token失败
            }
    
          }
        })
        
    },

    authByWechat() {
      const redictPage = window.location.href;
      this.wechatAuth.openAuthPage(encodeURIComponent(redictPage));
    },
    goback: function() {
      this.$router.push("/");
    },
    onSubmit: function() {
      if (!/[\u4e00-\u9fa5]{2,6}/.test(this.inputs.name)) {
        Toast("姓名只能是中文");
        return;
      }

      if (!check_card(this.inputs.id_number)) {
        Toast("请输入正确身份证号码");
        return;
      }

      if (!this.inputs.agreement) {
        Toast("必须勾选同意注册协助");
        return;
      }

      this.$validator.validateAll().then(result => {
        console.log("校验结果是: ", result, this.errors);
        if (result) {
          this.$http
            .post(
              "/api/user/create",
              _.extend(
                {},
                this.inputs,
                this.inputs.remember
                  ? {
                      openid: this.$store.state.openid
                    }
                  : {}
              ),
              { loading: true }
            )
            .then(result => {
              if (result) {
                this.$hideLoading();
                // this.$store.commit("login", result.data.data);
                // this.$router.replace("/");//
                Toast("注册成功");
                this.$router.replace("/"); //
              }
            });
        } else {
          if (this.errors.has("username")) {
            Toast("请填写正确的手机号");
            return;
          }

          if (this.errors.has("code")) {
            Toast("请填写正确的验证码");
            return;
          }

          if (this.errors.has("password")) {
            Toast("请填写6位以上的密码");
            return;
          }

          Toast("请正确填写需要的信息");
          return;
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../assets/less/var.less";

.enter-actions {
  padding: 15px;
  button {
    display: block;
    width: 100%;
    margin-top: 20px;
    height: 49px;
    font-size: 16px;

    &.van-button--default {
      color: gray;
    }

    img {
      vertical-align: middle;
      width: 20px;
    }
  }
}

.page-swipe {
  padding: 0px;
}
.logo {
  display: block;
  margin: 15px auto;
  width: 90px;
  height: auto;
}
.login-box {
  text-align: right;
}
.btn-box {
  text-align: center;
  display: block;
}
.van-cell-group {
  margin-top: 20px;
}
.btn-code {
  height: 30px;
  line-height: 0px;
  margin: 5px auto;
  color: white;
  background-color: @defaultColor;
}
.reg-box {
  background: white;
}
.van-checkbox {
  margin-top: 10px;
}

.login-action {
  display: block;
  width: 200px;
  text-align: center;
  margin: 20px auto;

  height: auto;
  padding: 15px 0;
  line-height: 0px;

  color: white;
  border: 1px solid @defaultColor;
  background-color: @defaultColor;
}
.btn-login {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;

  display: inline-block;
  color: @defaultColor;
  border: 1px solid @defaultColor;
  background-color: transparent;

  border-right: 0px;
  width: 100px;
  min-height: 30px;
  height: auto;
  padding: 15px 0;
  line-height: 0px;
}
.btn-register {
  display: inline-block;

  color: white;
  border: 1px solid @defaultColor;
  background-color: @defaultColor;

  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  border-left: 0px;
  width: 100px;
  min-height: 30px;
  padding: 15px 0;
  line-height: 0px;
  height: auto;
}

.contract-box {
  height: 90%;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/pages/enter.vue